<div class="visor-container unselectable" #Container id='visor-container' [style.width.px]="width"
  [style.height.px]="height" [style.transform]="'translate3d(' + left + 'px,' + top + 'px,' + '0px)'"
  style="display: none;" [ngClass]="{fullscreen: (isPageSmall)}" (click)="collapseAll()"
  (contextmenu)="collapseAll($event)">

  <app-visor-context-menu (activateTool)="clickExpandableTool($event.func,$event.args)"></app-visor-context-menu>

  <div class="h-100 w-100">
    <!-- TODO he tenido que sacrificar el Grid de momento, para poner la nueva carga de imágenes (al poner el scroll) -->
    <!-- <div class="row g-0" (dblclick)="toggleLock()" (auxclick)="onRightClick($event)"
      (mousedown)="onStartMouseDown($event)" [ngStyle]='getStyleForRows()'
      *ngFor='let r of [].constructor(layout.rows)'>
      <div CornerstoneLite [classList]='getClassForCols()' style="height: 100%;"
        (navigatedSerie)="$event=='next' ? nextImage() : prevImage()" *ngFor='let c of [].constructor(layout.columns)'>
      </div>
    </div> -->
    <div class="row g-0" (auxclick)="onRightClick($event)" (mousedown)="onStartMouseDown($event)"
      [ngStyle]='getStyleForRows()'>
      <div CornerstoneLite [classList]='getClassForCols()' style="height: 100%;"
        (navigatedSerie)="$event=='next' ? nextImage() : prevImage()">
      </div>
      <div style="position: absolute;top: 0;left: 0;width: 100%;height: 100%;" *ngIf="currentImage==null"
        id="thumbnail">
        <img class="placeholder-img" [src]="currentPNGImage">
        <span style="color: red;position: absolute;left:16px"
          [ngStyle]="{bottom: (isPageSmall) ? '60px' : '20px'}">Cargando imagen...</span>
      </div>
    </div>

    <app-series-scrollbar
      *ngIf="cornerstoneDirectives!=null && cornerstoneDirectives[0]?.imageList!=null && cornerstoneDirectives[0]?.imageList?.length!>1"
      [directive]="cornerstoneDirectives[0]" style="position: absolute; right: 0; width: 10px;"
      [style.top.px]="(isPageSmall ? 0 : 40)"
      [style.height]="(isPageSmall ? '100%' : 'calc(100% - 40px)')"></app-series-scrollbar>
  </div>

  <div class="" id='ArrowAnnotatePopup'
    style="display: none; position: absolute; top: 0; left: 0; width: 100%; height: 100%; background-color: rgba(128, 128, 128, 0.466); z-index: 200;">
    <div class="card"
      style="position: absolute; top: calc(50% - 80px); left: calc(50% - 125px); width: 250px; height: 160px;">
      <div class="card-header">
        Introduce el texto
      </div>
      <div class="card-body">
        <input type="text" class='form-control' autocomplete="off" id='ArrowAnnotatePopupInput'
          (keydown.enter)='ArrowAnnotatePopupButtonConfirm.click()'>
      </div>
      <div class="card-footer row g-0">
        <div class="col-1"></div>
        <div class="col-10">
          <button type="button" class='btn btn-primary w-100' id='ArrowAnnotatePopupButtonConfirm'
            #ArrowAnnotatePopupButtonConfirm>Aceptar</button>
        </div>
        <div class="col-1"></div>
      </div>
    </div>
  </div>

  <!-- <div class="tool-btn-container container-flex" style="top: 0;" *ngIf='!isPageSmall'>
        <div class="row g-0">
            <div class="tool-btn windowing col" (click)='activateTool("Wwwc")' *ngIf="showWindowingTool"
                title="Windowing: Permite ajustar brillo y contraste haciendo click sobre la imagen y arrastrando el cursor en vertical u horizontal">
                <span class='visor-icons icon-ww'></span>
            </div>
            <div class="tool-btn pan col" (click)='activateTool("Pan")'
                title='Mover: Permite mover la imagen haciendo click y arrastrando el cursor'>
                <span class='visor-icons icon-pan'></span>
            </div>
            <div class="tool-btn zoom col" (click)='activateTool("Zoom")'
                title='Zoom: Permite aumentar o disminuir el zoom haciendo click sobre la imagen y arrastrando el cursor hacia arriba o abajo'>
                <span class='visor-icons icon-zoom'></span>
            </div>
        </div>
    </div> -->
  <div class="top-banner advanced" style="z-index: 11; background: transparent !important;"
    *ngIf="!isPageSmall && tourService.guideTour.isActive()"></div>

  <div class="top-banner clickable" id="top-banner" [ngClass]="{advanced: advancedMode}" *ngIf="!isPageSmall"
    (mousedown)='startDragging($event)' (touchstart)="startDragging($event)">
    <!-- <div class="drag-handler unselectable tool-btn-container"  *ngIf='!isPageSmall' [ngClass]='{expanded: isDragging, transparent: advancedMode}'
      title='Permite mover la ventana del visor haciendo click sobre este icono y arrastrando el cursor por la pantalla'>
      <span class="material-icons unselectable" style="font-size: 2em;">
        open_with
      </span>
    </div> -->
    <button class="btn btn-close p-0 px-3" (click)="hide()" *ngIf='!isPageSmall'></button>

    <!-- BTN TOUR -->
    <!--     <button class="btn btn-tour" (click)="showVisorHelp()" *ngIf='!isPageSmall && !activeTour'> -->
    <button class="btn btn-tour" (click)="showVisorHelp()" *ngIf='!isPageSmall'>
      <svg width="25" height="30" viewBox="0 0 25 40" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          d="M28.3332 15.0001C28.3332 12.7899 27.4552 10.6703 25.8924 9.10752C24.3296 7.54472 22.21 6.66675 19.9998 6.66675C17.7897 6.66675 15.6701 7.54472 14.1073 9.10752C12.5445 10.6703 11.6665 12.7899 11.6665 15.0001C11.6665 15.4421 11.8421 15.866 12.1547 16.1786C12.4672 16.4912 12.8911 16.6667 13.3332 16.6667C13.7752 16.6667 14.1991 16.4912 14.5117 16.1786C14.8242 15.866 14.9998 15.4421 14.9998 15.0001C14.9998 14.0112 15.2931 13.0445 15.8425 12.2222C16.3919 11.4 17.1728 10.7591 18.0864 10.3807C19 10.0022 20.0054 9.90323 20.9753 10.0962C21.9452 10.2891 22.8361 10.7653 23.5354 11.4645C24.2346 12.1638 24.7108 13.0547 24.9038 14.0246C25.0967 14.9945 24.9977 15.9999 24.6192 16.9135C24.2408 17.8271 23.5999 18.608 22.7777 19.1574C21.9554 19.7068 20.9887 20.0001 19.9998 20.0001C19.5578 20.0001 19.1339 20.1757 18.8213 20.4882C18.5088 20.8008 18.3332 21.2247 18.3332 21.6667V25.0001C18.3332 25.4421 18.5088 25.866 18.8213 26.1786C19.1339 26.4912 19.5578 26.6667 19.9998 26.6667C20.4419 26.6667 20.8658 26.4912 21.1783 26.1786C21.4909 25.866 21.6665 25.4421 21.6665 25.0001V23.1667C23.5488 22.7825 25.2405 21.7598 26.4553 20.2716C27.6702 18.7834 28.3336 16.9212 28.3332 15.0001Z"
          fill="url(#paint0_linear_400_1738)" />
        <path
          d="M20.0002 33.3333C20.9206 33.3333 21.6668 32.5871 21.6668 31.6667C21.6668 30.7462 20.9206 30 20.0002 30C19.0797 30 18.3335 30.7462 18.3335 31.6667C18.3335 32.5871 19.0797 33.3333 20.0002 33.3333Z"
          fill="url(#paint1_linear_400_1738)" />
      </svg>
    </button>
    <!------------->

    <div class="collapsable-tool-btn-container" *ngFor='let expandableTool of expandableTools'>
      <div class='w-100 h-100'>
        <button type="button" (click)='showExpandableTool( expandableTool)'
          class="btn btn-sm btn-default collapsable-tool-btn-head" data-container='body' data-toggle="tooltip"
          data-placement="bottom" [title]="expandableTool.tools[expandableTool.selectedIndex].name">
          <span
            [ngClass]="expandableTool.tools[expandableTool.selectedIndex].icon+ ' ' + expandableTool.tools[expandableTool.selectedIndex].color"></span>
        </button>
        <button class="btn btn-primary collapsable-tool-btn-arrow" (click)='showExpandableTool(expandableTool)'>
          <svg style="transition: 0.5s;" [ngStyle]='{transform: (expandableTool.show) ? "rotate(-180deg)" : ""}'
            width="12" height="5" viewBox="0 0 15 6" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
              d="M7.12196 5.6462C7.45323 5.86137 7.88011 5.86137 8.21137 5.6462L14.0735 1.83863C14.9085 1.29632 14.5244 0 13.5288 0L1.80452 0C0.808912 0 0.424872 1.29632 1.25982 1.83863L7.12196 5.6462Z"
              fill="white" />
          </svg>
        </button>
        <div class="collapsable-tool-content"
          [ngStyle]='{height:(expandableTool.show) ? "calc(45px * " + expandableTool.tools.length + ")" : "0"}'>
          <div class="collapsable-tool row g-0 clickable" *ngFor='let tool of expandableTool.tools'
            [ngClass]='{"disabled-tool":tool.disabled}'
            (click)='selectExpandableTool(expandableTool, tool.index);clickExpandableTool(tool.func,tool.args)'>
            <div class="col-3 collapsable-tool-icon d-flex justify-content-center align-items-center">
              <span [ngClass]="tool.icon + ' ' + tool.color"></span>
            </div>
            <div class="col-9 d-flex align-items-center">
              <span>{{tool.name}}</span>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="my-btn-group collapsable-tool-btn-container ms-2">
      <div class="btn-reset-image clickable" (click)="resetImage()" *ngIf="advancedMode"
        title="Elimina las modificaciones realizadas sobre la imagen">
        <span class="visor-icons icon-reset green"></span>
      </div>
    </div>

    <div class="my-btn-group collapsable-tool-btn-container">
      <!-- Restaurar anotacion -->
      <div class="btn-undo-image clickable" (click)="HistoricToolDataService.restoreLastDeletedTool()"
        *ngIf="advancedMode && HistoricToolDataService.lastRemoved!=null"
        title="Restaura la última anotación eliminada">
        <svg xmlns="http://www.w3.org/2000/svg" height="24" viewBox="0 -960 960 960" width="24" class="green">
          <path
            d="M280-200v-80h284q63 0 109.5-40T720-420q0-60-46.5-100T564-560H312l104 104-56 56-200-200 200-200 56 56-104 104h252q97 0 166.5 63T800-420q0 94-69.5 157T564-200H280Z" />
        </svg>
      </div>
    </div>

  </div>

  <div class="pause-play-button tool-btn-container" title='Activa o desactiva el modo cine'
    *ngIf='!isLayoutActive && !isPageSmall && (hasNext || hasPrev)'>
    <span class="clickable" (click)='cornerstoneDirectives[0].isPlaying ? stopClip() : playClip()'>
      <svg xmlns="http://www.w3.org/2000/svg" height="24" viewBox="0 -960 960 960" width="24"
        *ngIf="cornerstoneDirectives[0].isPlaying">
        <path fill="white"
          d="M360-320h80v-320h-80v320Zm160 0h80v-320h-80v320ZM480-80q-83 0-156-31.5T197-197q-54-54-85.5-127T80-480q0-83 31.5-156T197-763q54-54 127-85.5T480-880q83 0 156 31.5T763-763q54 54 85.5 127T880-480q0 83-31.5 156T763-197q-54 54-127 85.5T480-80Zm0-80q134 0 227-93t93-227q0-134-93-227t-227-93q-134 0-227 93t-93 227q0 134 93 227t227 93Zm0-320Z" />
      </svg>
      <svg xmlns="http://www.w3.org/2000/svg" height="24" viewBox="0 -960 960 960" width="24"
        *ngIf="!cornerstoneDirectives[0].isPlaying">
        <path fill="white"
          d="m380-300 280-180-280-180v360ZM480-80q-83 0-156-31.5T197-197q-54-54-85.5-127T80-480q0-83 31.5-156T197-763q54-54 127-85.5T480-880q83 0 156 31.5T763-763q54 54 85.5 127T880-480q0 83-31.5 156T763-197q-54 54-127 85.5T480-80Zm0-80q134 0 227-93t93-227q0-134-93-227t-227-93q-134 0-227 93t-93 227q0 134 93 227t227 93Zm0-320Z" />
      </svg>
    </span>
  </div>

  <div class="tool-btn-container loading" *ngIf='imagesCacheService.gettingFile==true'>
    <div class="spinner-border text-light" role="status">
    </div>
  </div>

  <div class="prev-button tool-btn-container clickable" (click)='prevImage()' *ngIf='hasPrev'
    [ngStyle]="{position: (isPageSmall) ? 'fixed' : 'absolute'}">
    <svg xmlns="http://www.w3.org/2000/svg" height="24" viewBox="0 -960 960 960" width="24">
      <path fill="white" d="M560-240 320-480l240-240 56 56-184 184 184 184-56 56Z" />
    </svg>
  </div>
  <div class="next-button tool-btn-container clickable" (click)='nextImage()' *ngIf='hasNext'
    [ngStyle]="{position: (isPageSmall) ? 'fixed' : 'absolute'}">
    <svg xmlns="http://www.w3.org/2000/svg" height="24" viewBox="0 -960 960 960" width="24">
      <path fill="white" d="M504-480 320-664l56-56 240 240-240 240-56-56 184-184Z" />
    </svg>
  </div>

  <div class="" style="position: absolute; left: 10px; bottom: 10px;" *ngIf="isLocked">
    <span class="visor-icons icon-save_ko golden" style="font-size: 28px;"></span>
  </div>

  <!-- <div class="resize-handler unselectable tool-btn-container" (mousedown)='startResizing()'
    (touchstart)="startResizing()" *ngIf='!isPageSmall' [ngClass]='{expanded: isResizing}'
    title='Permite redimensionar la ventana del visor haciendo click sobr este icono y arrastrando el cursor'>
    <span class="material-icons unselectable" style="transform: rotate(90deg); font-size: 2em;">
      open_in_full
    </span>
  </div> -->

  <div class="top-banner clickable" id="top-banner" [ngClass]="{advanced: advancedMode}" *ngIf="isPageSmall"
    style="height: 3em;">
    <!-- <button class="btn btn-close p-0 px-3" (click)="hide()" *ngIf='!isPageSmall'></button> -->

    <!-- <button class="btn btn-close small" (click)="hide()" *ngIf='isPageSmall'>X</button> -->
    <button class="btn mobile-btn-close" style="margin-right: 5px;" (click)="hide()" *ngIf='isPageSmall'>
      <svg xmlns="http://www.w3.org/2000/svg" height="24" viewBox="0 -960 960 960" width="24">
        <path fill="#FFFFFF" d="m313-440 224 224-57 56-320-320 320-320 57 56-224 224h487v80H313Z" />
      </svg>
    </button>

    <div class="collapsable-tool-btn-container" *ngFor='let expandableTool of expandableTools'>
      <div class='w-100 h-100'>
        <button type="button" (click)='showExpandableTool( expandableTool)'
          class="btn btn-sm btn-default collapsable-tool-btn-head" data-container='body' data-toggle="tooltip"
          data-placement="bottom" [title]="expandableTool.tools[expandableTool.selectedIndex].name">
          <span
            [ngClass]="expandableTool.tools[expandableTool.selectedIndex].icon+ ' ' + expandableTool.tools[expandableTool.selectedIndex].color"></span>
        </button>
        <button class="btn btn-primary collapsable-tool-btn-arrow" (click)='showExpandableTool(expandableTool)'>
          <svg style="transition: 0.5s;" [ngStyle]='{transform: (expandableTool.show) ? "rotate(-180deg)" : ""}'
            width="12" height="5" viewBox="0 0 15 6" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
              d="M7.12196 5.6462C7.45323 5.86137 7.88011 5.86137 8.21137 5.6462L14.0735 1.83863C14.9085 1.29632 14.5244 0 13.5288 0L1.80452 0C0.808912 0 0.424872 1.29632 1.25982 1.83863L7.12196 5.6462Z"
              fill="white" />
          </svg>
        </button>
        <div class="collapsable-tool-content" style="top: 3.2em;"
          [ngStyle]='{height:(expandableTool.show) ? "calc(45px * " + expandableTool.tools.length + ")" : "0"}'>
          <div class="collapsable-tool row g-0 clickable" *ngFor='let tool of expandableTool.tools'
            [ngClass]='{"disabled-tool":tool.disabled}'
            (click)='selectExpandableTool(expandableTool, tool.index);clickExpandableTool(tool.func,tool.args)'>
            <div class="col-3 collapsable-tool-icon d-flex justify-content-center align-items-center">
              <span [ngClass]="tool.icon + ' ' + tool.color"></span>
            </div>
            <div class="col-9 d-flex align-items-center">
              <span>{{tool.name}}</span>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="my-btn-group collapsable-tool-btn-container ms-2">
      <div class="btn-reset-image clickable" (click)="resetImage()" *ngIf="advancedMode"
        title="Elimina las modificaciones realizadas sobre la imagen">
        <span class="visor-icons icon-reset green"></span>
      </div>
    </div>

    <div class="my-btn-group collapsable-tool-btn-container">
      <!-- Restaurar anotacion -->
      <div class="btn-undo-image clickable" (click)="HistoricToolDataService.restoreLastDeletedTool()"
        *ngIf="advancedMode && HistoricToolDataService.lastRemoved!=null"
        title="Restaura la última anotación eliminada">
        <svg xmlns="http://www.w3.org/2000/svg" height="24" viewBox="0 -960 960 960" width="24" class="green">
          <path
            d="M280-200v-80h284q63 0 109.5-40T720-420q0-60-46.5-100T564-560H312l104 104-56 56-200-200 200-200 56 56-104 104h252q97 0 166.5 63T800-420q0 94-69.5 157T564-200H280Z" />
        </svg>
      </div>
    </div>

  </div>

</div>